
import { db, serverTimestamp } from "../firebase";
import { UserPreferences, DEFAULT_PREFERENCES } from "../types/userPreferences";

const COLLECTION = "user_preferences";

export async function getUserPreferences(userId: string): Promise<UserPreferences> {
  try {
    const doc = await db.collection(COLLECTION).doc(userId).get();
    if (doc.exists) {
      return { ...DEFAULT_PREFERENCES, ...doc.data() } as UserPreferences;
    }
    return { ...DEFAULT_PREFERENCES, userId };
  } catch (e) {
    console.error("Error fetching preferences", e);
    return { ...DEFAULT_PREFERENCES, userId };
  }
}

export async function saveUserPreferences(userId: string, prefs: Partial<UserPreferences>): Promise<void> {
  try {
    await db.collection(COLLECTION).doc(userId).set({
      ...prefs,
      userId,
      updatedAt: serverTimestamp()
    }, { merge: true });
    
    // Cache for immediate synchronous access in some components
    localStorage.setItem(`legalops.prefs.${userId}`, JSON.stringify(prefs));
  } catch (e) {
    console.error("Error saving preferences", e);
    throw e;
  }
}

export function getCachedPreferences(userId: string): UserPreferences | null {
    const raw = localStorage.getItem(`legalops.prefs.${userId}`);
    return raw ? JSON.parse(raw) : null;
}
